export * from "./adapter-total-scheduled-hours-summary.interface";
